module.exports = __webpack_public_path__ + "img/pic27.b580a673.png";